export const coloredIconsLength: Record<string, number> = {
  Ukraine: 2,
  ['United-Kingdom']: 4,
};
